export const UPDATE_CHARACTER_LIST = "UPDATE_CHARACTER_LIST";
export const SET_SELECTED_CHARACTER_LOCATION_DATA =
  "SET_SELECTED_CHARACTER_LOCATION_DATA";
export const SET_SELECTED_CHARACTER = "SET_SELECTED_CHARACTER";
export const TOGGLE_POPUP_OPEN = "TOGGLE_POPUP_OPEN";
export const TOGGLE_LOADING_STATUS = "TOGGLE_LOADING_STATUS";
